<template>
  <div>
    <!-- Purpose block -->
    <div class="content-view-body">
      <div class="card-body" id="update_purpose" :class="{'pr-0 pl-0': showOnTask}">
        <div class="mb-2">
          <h5 class="h5" v-if="!showOnTask">
            <span class="float-right" v-if="showPurposeInput">
              <div class="text-right">
                <b-button class="btn-sm inline-edit-button"
                          variant="secondary"
                          @click="cancelPurposeForm"
                          qid="process-purpose-cancel-button"
                >
                  {{ $t('processes.legal_basis.create.cancel') }}
                </b-button>
                <b-button class="ml-3 mr-0 btn-sm inline-edit-button"
                          variant="success"
                          @click="formPurposeSubmit"
                          qid="process-purpose-submit-button"
                          v-if="isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], process)"
                >
                  {{ $t('processes.legal_basis.create.submit') }}
                </b-button>
              </div>
            </span>
            <span class="float-right btn btn-sm btn-edit mr-0"
                  @click="showPurposeInputFunction"
                  qid="edit-process-purpose"
                  v-if="!showPurposeInput && isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], process)"
            >
              <font-awesome-icon icon="pen"/>
            </span>
            {{ $t('processes.create.purpose_label') }}
          </h5>
          <h5 class="h5" v-if="showOnTask">
            <span class="float-right" v-if="showPurposeInput">
              <div class="text-right">
                <b-button class="btn-sm inline-edit-button"
                          variant="secondary"
                          @click="cancelPurposeForm"
                          qid="process-purpose-cancel-button"
                >
                  {{ $t('processes.legal_basis.create.cancel') }}
                </b-button>
                <b-button class="ml-3 mr-0 btn-sm inline-edit-button"
                          variant="success"
                          @click="formPurposeSubmit"
                          qid="process-purpose-submit-button"
                          v-if="isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], process)"
                >
                  {{ $t('processes.legal_basis.create.submit') }}
                </b-button>
              </div>
            </span>
            <span class="float-right btn btn-sm btn-edit mr-0"
                  @click="showPurposeInputFunction"
                  qid="edit-process-purpose"
                  v-if="!showPurposeInput && isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], process)"
            >
              <font-awesome-icon icon="pen"/>
            </span>
            &nbsp;
          </h5>
          <span v-if="!showOnTask">
            <span class="cursor-pointer task-label-open mr-2 ml-2 mr-2"
                  v-if="getTask('update_purpose')"
            >
              <UpdateSingleTaskModal
                  :task="myTasks[0]"
                  @reloadContent="reloadContent"
                  :editIcon="true"
              ></UpdateSingleTaskModal>
            </span>
            <span v-if="getGuide('update_purpose')">
              <GuideButton :guide="getGuide('update_purpose')"></GuideButton>
            </span>
          </span>

        </div>
        <div v-if="showPurposeInput">
          <b-form-textarea
            qid="edit-p-form-purpose"
            v-model="processEditPurpose"
            rows="6"
            :placeholder="$t('processes.create.purpose_placeholder')"
          ></b-form-textarea>
        </div>
        <div v-if="!showPurposeInput" class="section-container">
          <div v-if="process.purpose && process.purpose.length > descriptionLength">
            <p v-if="showFullPurpose" class="text-formatted">{{ process.purpose }}</p>
            <p v-if="!showFullPurpose" class="text-formatted">{{ process.purpose | truncate(descriptionLength) }}</p>
            <div class="text-center mt-3" @click="showFullPurpose=!showFullPurpose">
              <span class="cursor-pointer" v-if="!showFullPurpose">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPurpose">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="process.purpose && process.purpose.length <= descriptionLength"
             class="text-formatted"
          >{{ process.purpose }}</p>
          <p v-if="!process.purpose" class="text-muted">
            {{ $t('system.missing_input') }}
          </p>
        </div>
        <br>
      </div>
    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'PurposeBlock',
    data: function() {
      return {
        process: {},
        descriptionLength: config.descriptionLength,
        showFullPurpose: false,
        showPurposeInput: false,
        processEditDescription: '',
        processEditPurpose: '',

        error: '',
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      submitForm: {},
      task: {}
    },
    components: {
      Avatar,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      object: function (value) {
        this.process = value
        this.loadTasks('update_purpose');
      },
      submitForm: function (value) {
        if (value) {
          if (this.showPurposeInput) {
            this.formPurposeSubmit()
          }
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.process.id && this.$store.state.updatedObject.who_am_i == this.process.who_am_i) {
              this.process = this.$store.state.updatedObject
            }
          }
          this.loadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_purpose')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadContent()
        this.loadTasks('update_purpose');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.process.who_am_i,
              model_id: this.process.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Process' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Process',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showPurposeInputFunction() {
        this.showPurposeInput = true;
        this.processEditPurpose = this.process.purpose;
      },
      formPurposeSubmit() {
        let self = this;
        piincHttp.put('processes/' + this.process.slug, {
          purpose: this.processEditPurpose
        }).then(function(response) {
          self.process = response.data;
          self.showPurposeInput = false;
          self.loadTasks('update_purpose');
          self.$store.commit('storeUpdateContent', self.process);
          self.$toastr('success', self.$t('processes.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      cancelPurposeForm() {
        this.showPurposeInput = false;
        this.processEditPurpose = this.process.purpose;
      },
      loadContent() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.process = response.data;
        }, function() {});
      }
    },
    created () {
      this.process = this.object;

      if (this.showOnTask && !this.process.purpose) {
        this.showPurposeInput = true;
      }

      if (this.showOnTask) {
        this.loadContent()
      }

      if (this.process && this.process.slug) {
        this.loadTasks('update_purpose');
      }

      this.loadGuides('update_purpose');
    }
  }
</script>
